module.exports = __webpack_public_path__ + "c214ba5b71208ce8d94bea2bfb65d514.svg";